import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// CSS styling
import "../../styles/activitiesPublic.css";
import "../../styles/diplomaESG.css";

// Styled components
import styled from "styled-components";

// react responsive
import { useMediaQuery } from "react-responsive";

// Icons & Backgrounds
import BannerDiplomaESG from "../../images/eventCards/banner_DIP_PM_ESG.jpeg";
// import BrochureMMUSDImage from "../../images/eventCards/mm_usd_brochure_image.png";

// Icons & Backgrounds
import WhoShouldLearnIcon from "../../images/icons/WhoShouldLearnIcon.svg";
import BenefitIcon from "../../images/icons/BenefitIcon.svg";
import DeliveryMethodIcon from "../../images/icons/DeliveryMethodIcon.svg";
import PrerequisiteIcon from "../../images/icons/PrerequisiteIcon.svg";
import TuitionFeeIcon from "../../images/icons/TuitionFeeIcon.svg";
import classSchedule from "../../images/diplomaESG/classSchedule.png";
import paymentScheduleAndScholarship from "../../images/diplomaESG/paymentScheduleAndScholarship.png";
import interlink_logo_new from "../../images/diplomaESG/interlink_logo_new.png";
import dip_pm_esg_page_infographic_banner from "../../images/diplomaESG/dip_pm_esg_page_infographic_banner.png";

// Components
import Seo, { organizationRef } from "../../components/Seo.js";
import Header from "../../components/Header.js";
import Footer from "../../components/Footer.js";
import ContainerText from "../../components/Container.js";

// Helpers
import { absoluteUrl } from "../../helpers/seo";

const DiplomaESG = () => {
  const isMobileSize = useMediaQuery({ query: "(max-width: 640px)" });

  const [infoName, setInfoName] = useState("classSchedule");

  const [fullScreenImage, setFullScreenImage] = useState(null);

  // click to view image full screen
  const openFullScreen = (imageUrl) => {
    setFullScreenImage(imageUrl);
  };

  // click to close image full screen
  const closeFullScreen = () => {
    setFullScreenImage(null);
  };

  // Options renderer
  function renderOptions() {
    if (infoName === "classSchedule") {
      return (
        <div className="scheduleESGContainer">
          <img src={classSchedule} alt="Class schedule" />
        </div>
      );
    } else if (infoName === "paymentScheduleAndScholarship") {
      return (
        <div className="scheduleESGContainer">
          <img
            src={paymentScheduleAndScholarship}
            alt="Payment schedule and scholarship"
          />
        </div>
      );
    } else {
      return (
        <div>
          <p>Data not found, please try another options...</p>
        </div>
      );
    }
  }

  return (
    <div>
      <Seo
        title="Diploma of Project Management for ESG"
        description="Study the Australian Diploma of Project Management for ESG and sustainability projects with ISA Academy and Interlink, delivered in Indonesia."
        path="/diploma-pm-for-esg"
        image={BannerDiplomaESG}
        imageAlt="Diploma of Project Management for ESG/Sustainability Projects"
        breadcrumbs={[
          { name: "ISA Academy", path: "/academy" },
          { name: "Diploma PM for ESG", path: "/diploma-pm-for-esg" },
        ]}
        jsonLd={{
          "@type": "Course",
          name: "Diploma of Project Management for ESG/Sustainability Projects",
          description:
            "A diploma in project management applied to ESG and sustainability projects, with certification from Australia, delivered in Indonesia by ISA Academy.",
          url: absoluteUrl("/diploma-pm-for-esg"),
          provider: organizationRef,
          educationalCredentialAwarded: "Diploma of Project Management",
          coursePrerequisites:
            "Bachelor degree; good English in writing and speaking; at least 5 years of experience with project management",
          inLanguage: "en",
        }}
      />
      <Header />
      <div>
        <ContainerText
          props={
            <div
              className="activityPublicDetailCardContainerDesc"
              style={{ margin: "25px" }}
            >
              <div style={{ marginTop: "10em", marginBottom: "3em" }}>
                <div
                  className="paragraf"
                  style={{
                    color: "#FF9F1E",
                    // fontSize: isMobileSize ? "16px" : "20px",
                    fontWeight: "700",
                  }}
                >
                  ISA Academy
                </div>
                <h1
                  className="headerDescription seoH1Sized"
                  style={{
                    // fontSize: isMobileSize ? "35px" : "45px",
                    color: "#0D4C86",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  Diploma of Project Management for ESG/Sustainability Projects
                  & Certification form Australia
                </h1>
              </div>
              <div
                className="interlinkImageContainer"
                style={{ marginBottom: "3em" }}
              >
                <img src={interlink_logo_new} alt="Interlink" />
              </div>
              <div
                className="founderStoryPublicCardPicture"
                onClick={() => openFullScreen(BannerDiplomaESG)}
                style={{
                  marginBottom: "5vh",
                  height: "100%",
                }}
              >
                <img src={BannerDiplomaESG} alt={"Banner Diploma ESG"} />
              </div>
              <div className="dipPmESGDescContainer">
                <div
                  className="dipPmESGDescEachContainer"
                  style={{ marginBottom: "8vh" }}
                >
                  <div className="dipPmESGDescEachContainerTitle">
                    <img src={WhoShouldLearnIcon} alt="" loading="lazy" />
                    <div className="dipPmESGDescEachContainerTitleLabel title">
                      Who should learn
                    </div>
                  </div>
                  <div className="dipPmESGDescEachContainerTitleHr" />
                  <div className="dipPmESGDescEachContainerDescription paragraf">
                    <div className="dipPmESGDescEachContainerEachDescription">
                      1. ESG Practitioners (Officers, Staffs, Managers): Anybody
                      who is planning, leading, managing, monitoring, controling
                      and evaluating ESG/CSR/Sustainability P3 (Projects,
                      Program, Portfolio)
                    </div>
                    <div
                      className="dipPmESGDescEachContainerEachDescription"
                      style={{ marginTop: "3vh" }}
                    >
                      2. Those who want to learn and apply P3 to an ESG context
                    </div>
                  </div>
                </div>
                <div className="dipPmESGDescEachContainer">
                  <div className="dipPmESGDescEachContainerTitle">
                    <img src={BenefitIcon} alt="" loading="lazy" />
                    <div className="dipPmESGDescEachContainerTitleLabel title">
                      Benefit
                    </div>
                  </div>
                  <div className="dipPmESGDescEachContainerTitleHr" />
                  <div className="dipPmESGDescEachContainerDescription paragraf">
                    <ul>
                      <li>
                        Getting Diploma Degree from Government of Australia
                      </li>
                      <li>
                        Graduate from Australia Polytechnic, study in Indonesia
                      </li>
                      <li>
                        Getting Certification of Project Management from
                        Australia Institute of Project Management
                      </li>
                      <li>
                        Possibility to get points for Australia Visa Application
                      </li>
                      <li>
                        Get opportunity to do "Professional Immersion Program"
                        in Sydney at Australian Companies (at additional
                        investment)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="dipPmESGDescContainer">
                <div
                  className="dipPmESGDescEachContainer"
                  style={{ marginBottom: "8vh" }}
                >
                  <div className="dipPmESGDescEachContainerTitle">
                    <img src={DeliveryMethodIcon} alt="" loading="lazy" />
                    <div className="dipPmESGDescEachContainerTitleLabel title">
                      Delivery methods
                    </div>
                  </div>
                  <div className="dipPmESGDescEachContainerTitleHr" />
                  <div className="dipPmESGDescEachContainerDescription paragraf">
                    <div
                      className="dipPmESGDescEachContainerEachDescription"
                      style={{ fontWeight: "700" }}
                    >
                      Module 1: (6 days)
                    </div>
                    <div className="dipPmESGDescEachContainerEachDescription">
                      Day 1 and 2 : Offline/In Class Room setting;
                    </div>
                    <div className="dipPmESGDescEachContainerEachDescription">
                      Day 3 until 6 : Online
                    </div>
                    <div
                      className="dipPmESGDescEachContainerEachDescription"
                      style={{ fontWeight: "700" }}
                    >
                      Module 2: (6 days)
                    </div>
                    <div
                      className="dipPmESGDescEachContainerEachDescription"
                      style={{ fontWeight: "700" }}
                    >
                      Module 3: (6 days)
                    </div>
                    <div
                      className="dipPmESGDescEachContainerEachDescription"
                      style={{ fontWeight: "700" }}
                    >
                      Module 4: (6 days)
                    </div>
                    <div className="dipPmESGDescEachContainerEachDescription">
                      <b style={{ fontWeight: "700" }}>Independent works: </b>
                      Homeworks/ Research and Assigments during and between
                      Modules (6 - 12 months)
                    </div>
                    <div
                      className="dipPmESGDescEachContainerEachDescription"
                      style={{
                        fontWeight: "700",

                        marginTop: "3vh",
                      }}
                    >
                      Teaching time:
                    </div>
                    <div style={{ marginBottom: "3vh" }}>
                      <ul>
                        <li>09:00 - 12:00</li>
                        <li>13:00 - 16:00</li>
                      </ul>
                    </div>
                    <div
                      style={{
                        marginTop: "3vh",
                        marginBottom: "5vh",
                      }}
                    >
                      <b style={{ fontWeight: "700" }}>Start on</b> 1 December
                      2024 - 30 January 2026
                    </div>
                    <div
                      style={{
                        marginBottom: "3vh",
                        fontWeight: "700",
                      }}
                    >
                      Optional Trip to Australia (additional investment is
                      required)
                    </div>
                    <div>
                      Professional Immersion Project: Visit to Australia's
                      Companies for 2 Days
                    </div>
                  </div>
                </div>
                <div className="dipPmESGDescEachContainer">
                  {/* tuition fee hide for now */}
                  {/* <div className="dipPmESGDescEachContainerTitle">
                    <img src={TuitionFeeIcon} alt="Tuition fee icon" />
                    <div className="dipPmESGDescEachContainerTitleLabel title">
                      Tuition fee
                    </div>
                  </div>
                  <div className="dipPmESGDescEachContainerTitleHr" />
                  <div
                    className="dipPmESGDescEachContainerDescription paragraf"
                    style={{ marginBottom: "8vh" }}
                  >
                    <div
                      className="dipPmESGDescEachContainerEachDescription"
                      style={{ fontWeight: "700", marginBottom: "3vh" }}
                    >
                      Rp 65.000.000,-
                    </div>
                    <div className="dipPmESGDescEachContainerEachDescription">
                      Installment up to 3 times*
                    </div>
                    <div className="dipPmESGDescEachContainerEachDescription">
                      Please contact us for further information
                    </div>
                  </div> */}
                  <div className="dipPmESGDescEachContainerTitle">
                    <img src={PrerequisiteIcon} alt="" loading="lazy" />
                    <div className="dipPmESGDescEachContainerTitleLabel title">
                      Prerequisite
                    </div>
                  </div>
                  <div className="dipPmESGDescEachContainerTitleHr" />
                  <div className="dipPmESGDescEachContainerDescription paragraf">
                    <div className="dipPmESGDescEachContainerEachDescription">
                      1. Bachelor Degree
                    </div>
                    <div className="dipPmESGDescEachContainerEachDescription">
                      2. Good English both in writing & speaking
                    </div>
                    <div className="dipPmESGDescEachContainerEachDescription">
                      3. Dealing with Project Management for at least 5 years
                      (can be Engineering or Community Development Projects or
                      other type of projects)
                    </div>
                  </div>
                </div>
              </div>
              {/* <MentorOptions>
                <MentorOptionSelect
                  onClick={() => setInfoName("classSchedule")}
                  className={infoName}
                  match="classSchedule"
                >
                  <MentorOptionText className="paragraf">
                    Class schedule
                  </MentorOptionText>
                  <MentorOptionLine
                    className={infoName}
                    match="classSchedule"
                  />
                </MentorOptionSelect>
                <MentorOptionSelect
                  onClick={() => setInfoName("paymentScheduleAndScholarship")}
                  className={infoName}
                  match="paymentScheduleAndScholarship"
                >
                  <MentorOptionText className="paragraf">
                    Payment schedule and scholarship
                  </MentorOptionText>
                  <MentorOptionLine
                    className={infoName}
                    match="paymentScheduleAndScholarship"
                  />
                </MentorOptionSelect>
              </MentorOptions> */}
              {/* table schedule hide for now */}
              {/* <MentorOptions>
                <MentorOptionSelect
                  onClick={() => setInfoName("classSchedule")}
                  className={infoName}
                  match="classSchedule"
                >
                  <MentorOptionText className="paragraf">
                    Class schedule
                  </MentorOptionText>
                </MentorOptionSelect>
                <MentorOptionSelect
                  onClick={() => setInfoName("paymentScheduleAndScholarship")}
                  className={infoName}
                  match="paymentScheduleAndScholarship"
                >
                  <MentorOptionText className="paragraf">
                    Payment schedule and scholarship
                  </MentorOptionText>
                </MentorOptionSelect>
              </MentorOptions>
              <MentorOptions>
                <MentorOptionSelect className={infoName} match="classSchedule">
                  <MentorOptionLine
                    className={infoName}
                    match="classSchedule"
                  />
                </MentorOptionSelect>
                <MentorOptionSelect
                  className={infoName}
                  match="paymentScheduleAndScholarship"
                >
                  <MentorOptionLine
                    className={infoName}
                    match="paymentScheduleAndScholarship"
                  />
                </MentorOptionSelect>
              </MentorOptions>
              <MentorInvisibleLine />
              {renderOptions()} */}
              <div
                className="dipPmESGDescEachContainerTitle"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "15vh",
                  marginBottom: "4vh",
                }}
              >
                <div className="dipPmESGDescEachContainerTitleLabel headerDescription">
                  Registration procedures, payment and class schedule
                </div>
              </div>
              <div
                className="buttonDownloadHereDiplomaESGContainer"
                style={{ marginBottom: "5vh" }}
              >
                <Link
                  to="/diploma-pm-for-esg/download-file-form/registration-procedures-payment-and-class-schedule"
                  className="btn paragraf"
                >
                  Download here
                </Link>
              </div>
              <div className="buttonDiplomaESGContainer">
                <Link
                  to="/diploma-pm-for-esg/registration-form"
                  className="btn paragraf"
                >
                  Pre-registration form
                </Link>
              </div>
              <div
                className="dipPmESGDescEachContainerTitle"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "15vh",
                  marginBottom: "4vh",
                }}
              >
                <div className="dipPmESGDescEachContainerTitleLabel headerDescription">
                  Download Diploma PM for ESG Brochure
                </div>
              </div>
              <div
                className="buttonDiplomaESGContainer"
                style={{ marginBottom: "15vh" }}
              >
                <Link
                  to="/diploma-pm-for-esg/download-file-form/dip-pm-esg"
                  className="btn paragraf"
                >
                  Click to download
                </Link>
              </div>
              <MentorInvisibleLine />
              <div
                className="dipPmESGDescEachContainerTitle"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10vh",
                  marginBottom: "4vh",
                }}
              >
                <div className="dipPmESGDescEachContainerTitleLabel headerDescription">
                  Infographic about ESG & Sustainability
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="founderStoryPublicCardPicture"
                  style={{
                    height: "100%",
                    width: isMobileSize ? "75%" : "50%",
                  }}
                >
                  <img
                    src={dip_pm_esg_page_infographic_banner}
                    alt="Infographic about ESG & Sustainability"
                    loading="lazy"
                  />
                </div>
              </div>
              <div
                className="buttonDiplomaESGContainer"
                style={{ marginBottom: "15vh" }}
              >
                <Link
                  to="/diploma-pm-for-esg/download-file-form/infographic-esg-sustainability"
                  className="btn paragraf"
                >
                  Click to download
                </Link>
              </div>
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="founderStoryPublicCardPicture"
                  style={{
                    height: "100%",
                    width: isMobileSize ? "75%" : "50%",
                  }}
                >
                  <img src={BrochureMMUSDImage} alt={"Banner Diploma ESG"} />
                </div>
              </div> */}
              {/* <div
                className="buttonDiplomaESGContainer"
                style={{ marginBottom: "15vh" }}
              >
                <button
                  type="submit"
                  className="btn"
                  onClick={() =>
                    navigate("/diploma-pm-for-esg/download-file-form/mm-usd")
                  }
                >
                  <div style={{ marginLeft: "4vw", marginRight: "4vw" }}>
                    Download brochure MM-USD
                  </div>
                </button>
              </div> */}
            </div>
          }
        />
        {fullScreenImage && (
          <div
            className="image-viewer full-screen"
            onClick={closeFullScreen}
            onKeyDown={closeFullScreen}
            tabIndex={0}
          >
            <div className="image-container">
              <img src={fullScreenImage} alt="Full-Screen Image" />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default DiplomaESG;

const MentorOptions = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const MentorOptionSelect = styled.div`
  color: ${({ className, match }) =>
    className === match ? "#FF9902" : "#C4C4C4"};
  font-weight: ${({ className, match }) => (className === match ? "bold" : "")};
  /* flex-grow: 1; // Important */
  width: 50%;
`;

const MentorOptionLine = styled.hr`
  opacity: ${({ className, match }) => (className === match ? 1 : 0)};
  padding: 2px;
  margin-top: 0.5em;
  // width: 33vw;
`;

const MentorInvisibleLine = styled.hr`
  opacity: 0.2;
  margin-top: -20px;
  padding: 2px;
`;

const MentorOptionText = styled.p`
  text-align: center;
  padding: 0 1em 0;
  margin-bottom: 0;
  cursor: pointer;
  color: #000000;
  &:hover {
    font-weight: bold;
  }

  &:hover + ${MentorOptionLine} {
    opacity: 1;
    transition: 0.2s;
    font-weight: bold;
  }
`;
